import { render } from "./welcomePage.vue?vue&type=template&id=6ea0fa96&scoped=true"
import script from "./welcomePage.vue?vue&type=script&lang=js"
export * from "./welcomePage.vue?vue&type=script&lang=js"

import "./welcomePage.vue?vue&type=style&index=0&id=6ea0fa96&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea0fa96"]])

export default __exports__